import AlertMessage from '../oc-alert-message';

const CMSAlertMessage = ({ className, dismissable = false, message, title, type = 'black' }) => (
  <AlertMessage
    alertIcon
    className={`page-alert ${className}`.trim()}
    dismissable={dismissable}
    message={message}
    title={title}
    type={type}
  />
);

export default CMSAlertMessage;
